import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { bookhalfIcon, calendarIcon101, coursesIcon, deadlineIcon, playBlueIcon } from '../../../constants/icons';
import { styled } from '@mui/material/styles';
import Form from 'olive-react-myoneui/lib/Form';
import Row from 'olive-react-myoneui/lib/Row';
import Col from 'olive-react-myoneui/lib/Col';
import Button from "olive-react-myoneui/lib/Button";
import Rating from '@mui/material/Rating';
import ModalCommon from '../ModalCommon';
import { postBundleReview } from '../../../../api/afterLogin/bundles';

export default function IntroCardBundle(props) {
  const { id,title, imgSrc, deadlineText, subTitle, onPlayBtnClick, initialRating, className, coursesCount, eventsCount, trainingCoursesCount, instructorName, showRating, asRatingUpdate, overallRating, isSelfRated } = props;

  const [validated, setValidated] = useState(false);
  const [reviewDesc, setreviewDesc] = useState('');
  const [postRating, setPostRating] = useState(0);
  const [errorRating, setErrorRating] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showThankModal, setShowThankModel] = useState(false);
  const [showMessage, setShowMessage] = useState('');
  const maxDescLength = 1000;
  const configData = useSelector((state) => state.config);

  const StyledRating = styled(Rating)({
    '& .MuiRating-icon': {
      color: '#a4a4a4',
    },
    '& .MuiRating-iconFilled': {
      color: '#f8c068',
    },
    '& .MuiRating-iconHover': {
      color: '#f8c068',
    },
  });

  const formatCount = (count, singular, plural) => (count === 1 ? singular : plural);

  const handleCloseModal = () => {
    setShowModal(false);
    setShowThankModel(false);
    setShowMessage('');
  }

  const handleDescChange = (e) => {
    if (e.target.value.length <= maxDescLength) {
        setreviewDesc(e.target.value);
    }
  };

  const handleShowModal = () => {
    setShowModal(true)
  };

  const handleSelfModal = () => {
    setShowThankModel(true);
    setShowMessage("You've already rated this bundle");
  };

  const handleSubmit = async (event) => {
    event.preventDefault(); 
    const form = event.currentTarget;
    
    if (form.checkValidity() === false && postRating === 0) {
      setErrorRating(true);
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
      return;
    }
    if (reviewDesc === '') {
      setValidated(true);
      return;
    }
    const postParams = {
      bundle_id: id,
      rating: postRating ?? 0,
      review: reviewDesc
    };

    if (postParams.rating === 0) {
      setErrorRating(true);
      return;
    }
    const response = await postBundleReview(configData.access_token, postParams);

    if (response) {
      setShowModal(false);
      setShowThankModel(true);
      setShowMessage(response.status === 200 ? 'Review submitted successfully' : 'Review submission failed');
      if (response.status === 200) {
        asRatingUpdate();
      }
    }
  };


  return (
    <>
    <div className={`intro-card-wrapper ${className || ''}`}>
      {title && <h2>{title}</h2>}
      <div className="intro-card-holder">
        <div className="intro-card">
          <img
            loading="lazy"
            src={imgSrc}
            alt="Resume learning"
          />
          <img
            className="image-shadow"
            loading="lazy"
            src={imgSrc}
            alt="Resume learning"
          />
          {onPlayBtnClick &&
          <span
            role="button"
            className="play-icon"
            onClick={onPlayBtnClick}
          >
            {playBlueIcon}
          </span>
          }
        </div>
        <div className="intro-card-info">
          <div className="myk__course-deadline_ratings">
            <span className="intro-card-date">
               {deadlineIcon} {deadlineText}
             </span>
            {showRating &&
              <div className="myk__stu-rating d-flex align-items-center gap-2" onClick={isSelfRated ? handleSelfModal : handleShowModal}>
                <div className="rating-label">Rate:</div>
                 <StyledRating name="half-rating" defaultValue={overallRating} precision={0.5} size="small" disabled/>
              </div>
            }
          </div>
          {subTitle && <h4 title={subTitle}>{subTitle}</h4>}
          <div className="myk__course-bundle-counts">
            <ul>
              <li>{coursesIcon} <span>{coursesCount} {formatCount(coursesCount, 'Course', 'Courses')}</span></li>
              <li>{calendarIcon101} <span>{eventsCount} {formatCount(eventsCount, 'Event', 'Events')}</span></li>
              <li>{calendarIcon101} <span>{trainingCoursesCount} {formatCount(trainingCoursesCount, 'Training Course', 'Training Courses')}</span></li>
              {instructorName && <li>{bookhalfIcon} <span>Instructed By: <strong>{instructorName || 'Admin'}</strong></span></li>}
            </ul>
          </div>
        </div>
      </div>
    </div>
      <ModalCommon
        show={showModal}
        onClose={handleCloseModal}
        title="Leave a Review"
        className="myk__stu-question-modal"
        >
        <div className="text-start">
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="formGroupReviewDesc">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                        as="textarea"
                        placeholder="Type your review"
                        style={{ height: '100px' }}
                        maxLength={maxDescLength}
                        onChange={handleDescChange}
                        required
                    />
                    <Form.Control.Feedback type="invalid">
                    Please provide your review.
                    </Form.Control.Feedback>
                    <p className="mt-2 text-gray text-end">Total: {reviewDesc.length}/{maxDescLength} characters</p>
                </Form.Group>
                <Row>
                  <Col>
                      <div className="myk__stu-rating myk__stu-rating-modal d-flex align-items-center gap-2">
                        <div className="rating-label">Rate:</div>
                        <StyledRating name="half-rating" defaultValue={postRating} precision={1} size="small" onChange={(event, newValue) => {setErrorRating(false);setPostRating(newValue)}} />
                        <p style={{color: 'red'}}><small>{errorRating && 'Please select a rating.'}</small></p> 
                      </div>
                  </Col>
                </Row>
                <Row>
                    <Col className="text-end mt-3">
                        <Button variant="default" onClick={handleCloseModal}>Cancel</Button>
                        <Button variant="primary" type="submit">Post Review</Button>
                    </Col>
                </Row>
            </Form>
        </div>
      </ModalCommon>
    
      <ModalCommon
        show={showThankModal}
        onClose={handleCloseModal}
        title=""
        className="myk__stu-question-modal"
        >
        <div className="text-start">
          <Row>
            <Col>
                <div className="myk__stu-rating myk__stu-rating-modal d-flex align-items-center gap-2">
                  <p>{showMessage}</p> 
                </div>
            </Col>
          </Row>
          <Row>
              <Col className="text-end mt-3">
                  <Button variant="primary" onClick={handleCloseModal}>OK</Button>
              </Col>
          </Row>
        </div>
      </ModalCommon>
    </>
  );
}
